import React, { useState, useEffect } from "react";
import TagManager from "react-gtm-module";
import Logo from "../assets/mainlogo.png";

function Store() {
  const [screenHeight, setScreenHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isLaptopMessageShown, setIsLaptopMessageShown] = useState(false);

  const gtmId = "GTM-T4QRDGLB";
  const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
  };

  useEffect(() => {
    // Function to update screen height
    const updateHeight = () => {
      setScreenHeight(window.innerHeight);
    };

    // Initial update of screen height
    updateHeight();

    // Event listener for window resizing
    window.addEventListener("resize", updateHeight);

    // Determine if user is on mobile
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsMobile(/android|iphone|ipad|ipod/i.test(userAgent));

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  useEffect(() => {
    initializeTagManager();
    // Function to determine platform and redirect accordingly
    const redirectBasedOnPlatform = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isAndroid = /android/i.test(userAgent);

      if (!isIOS && !isAndroid) {
        // Display message for users on laptops or desktops
        setIsLaptopMessageShown(true);
      } else {
        const schemeURL = "TheBooker://store/123"; // Custom URL scheme
        const appStoreURL =
          "https://apps.apple.com/cl/app/thebooker/id6503916811?l=en-GB"; // Apple App Store URL
        const playStoreURL =
          "https://play.google.com/store/apps/details?id=com.thebooker"; // Google Play Store URL

        // Attempt to redirect to the custom URL scheme (app) if on mobile
        window.location.href = schemeURL;

        // Setup a timeout to redirect to the store if the app is not installed
        const timeout = setTimeout(() => {
          if (isIOS) {
            window.location.href = appStoreURL;
          } else if (isAndroid) {
            window.location.href = playStoreURL;
          }
        }, 200);

        // Listen for visibility change or focus events to clear timeout
        const handleVisibilityChange = () => {
          clearTimeout(timeout);
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Cleanup function to remove event listener
        return () => {
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange
          );
        };
      }
    };

    // Call the redirect function when component mounts
    redirectBasedOnPlatform();
  }, []);

  return (
    <div
      style={{
        flex: 1,
        flexDirection: "column",
        width: "100%",
        height: screenHeight,
        backgroundColor: "#008a80",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {!isMobile && isLaptopMessageShown && (
        <div style={{ textAlign: "center", color: "white" }}>
          <img alt="store" src={Logo} style={{ width: 200, height: 200 }} />
          <h2>You are viewing on a laptop or desktop</h2>
          <p>Switch To a Mobile Phone And Download Our App</p>
        </div>
      )}
      {isMobile && (
        <div
          className="hover-effect m-0 play-logo"
          style={{ textAlign: "center" }}
        >
          <img alt="store" src={Logo} style={{ width: 200, height: 200 }} />
          <p
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "7%",
              color: "white",
            }}
          >
            If you are not redirected,{" "}
            <a href="#" onClick={() => window.location.reload()}>
              click here
            </a>
            .
          </p>
        </div>
      )}
    </div>
  );
}

export default Store;
